import React from 'react';

import cn from 'classnames';
import { Controller } from 'react-hook-form';

import { getPlainTextFromHtml } from '@shared/helpers';
import { TextEditor } from '@shared/ui';

import { IFormFieldProps } from '../../../model/types';
import cls from '../EventJournalModal.module.css';

export const DescriptionField = ({ control, t, error, isDisabled }: IFormFieldProps) => (
    <Controller
        key="description"
        name="description"
        control={control}
        rules={{
            validate: (value) => {
                const plainText = getPlainTextFromHtml(value);
                if (!plainText) {
                    return t('field.required');
                }
                if (plainText.length > 2000) {
                    return t('JournalEvents.EventJournalModal.Description.Error.Length');
                }
                return true;
            },
        }}
        render={({ field }) => (
            <TextEditor
                {...field}
                value={field.value ?? ''}
                inputName="text-editor"
                onChange={field.onChange}
                placeholder={t('TaskModal.TextEditor.placeholder')}
                readOnly={false}
                isDisabled={isDisabled}
                classes={cn(cls.TextEditor, cls.DescriptionTextEditor)}
                textEditorClassName={cls.DescriptionTextEditorInner}
                textEditorContentClassName={cn(
                    cls.TextEditorContent,
                    cls.DescriptionTextEditorContent
                )}
                errorText={error}
            />
        )}
    />
);
